import * as Yup from "yup";
import { FORM_ERROR_MESSAGES, TIMEZONE } from "@shared/constants";
import { Hospital, Station } from "@shared/models";
import { actions as stationActions, selectors as stationSelectors } from "@containers/Station/store/";
import { Option, USAGE_STATUS } from "@shared/interfaces";
import {
  CreateSensorDataRestoringRequesFormShape,
  CreateSensorDataRestoringRequestRequest,
} from "@containers/SensorDataRestoringRequest/interfaces";
import { formatDateToTz } from "@shared/utils";

export const validationSchema: Yup.SchemaOf<CreateSensorDataRestoringRequesFormShape> = Yup.object().shape({
  station: Yup.object()
    .shape({
      value: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED),
      label: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED),
    })
    .required(FORM_ERROR_MESSAGES.REQUIRED)
    .nullable(),
  start_date: Yup.date().required(FORM_ERROR_MESSAGES.REQUIRED).nullable(),
  end_date: Yup.date().required(FORM_ERROR_MESSAGES.REQUIRED).nullable(),
  timezone: Yup.string().required(FORM_ERROR_MESSAGES.REQUIRED).nullable(),
});

export const getInitValues = (): CreateSensorDataRestoringRequesFormShape => {
  return {
    station: null,
    start_date: null,
    end_date: null,
    timezone: null,
  };
};

export const getHandlers = (hospital: Option | null) => {
  const handlers = {
    station: {
      getData: (search: string) =>
        stationActions.getStations.request({
          search,
          page: 0,
          limit: 20,
          usage_status: USAGE_STATUS.ALL,
          hospital,
        }),
      selectData: stationSelectors.getStations,
      prepareOptionFunction: (item: Station): Option => {
        return { label: item.station_code, value: String(item.id) };
      },
      loadingAction: stationActions.getStations,
    },
  };

  return handlers;
};

export const prepareSubmitValue = (
  shape: CreateSensorDataRestoringRequesFormShape,
  hospital: Hospital,
): CreateSensorDataRestoringRequestRequest => {
  const timezone = shape.timezone || TIMEZONE.UTC;

  return {
    hospital_id: hospital.id,
    station_id: Number(shape.station?.value),
    start_date: formatDateToTz(shape.start_date as Date, timezone),
    end_date: formatDateToTz(shape.end_date as Date, timezone),
    timezone: timezone,
  };
};
